import React, { createContext, useState, useEffect } from 'react';
import { showError } from 'utils/alerts';

import { useDebounce } from 'hooks/useDebounce';
export const ListContext = createContext({});

export const ListProvider = ({ 
	lastPageName,
	fetch,
	children,
	orderBy: orderByDefault
}: {
	lastPageName: string;
	fetch: Function;
	children: React.ReactNode;
	orderBy?: { id: string; desc: boolean; }
}) => {
	const [list, setList] = useState<Array<User>>([]);
	const [listData, setListData] = useState<ListDataType>({});
	const [orderBy, setOrderBy] = useState<{ id: string; desc: boolean; }>(orderByDefault!);
	const [filter, setFilter] = useState();
	const debounceSearchFilter = useDebounce(filter, 500);

	const [filterText, setFilterText] = useState();
	// const debouncedSearchText = useDebounce(filterText, 500);
	const [fetching, setFetching] = useState<boolean>(false);

	useEffect(() => {
		setListData({ ...listData, currentPage: 0 });
	}, [orderBy, debounceSearchFilter]);

	useEffect(() => {
		!fetching && fetchList();
	}, [listData]);

	const fetchList = async () => {
		try {
			setFetching(true);
			let current =
				listData.currentPage !== undefined
					? listData.currentPage
					: Number(sessionStorage.getItem(lastPageName)) || 0;
			const { data, currentPage, totalPages, totalItems } = await fetch(
				current,
				listData.size || 10,
				filter,
				orderBy ? `${orderBy?.id} ${orderBy?.desc ? 'desc' : 'asc'}` : undefined
				);

			!list.length &&
				setListData({
					currentPage: Number(sessionStorage.getItem(lastPageName)) || 0,
					totalPages,
					totalItems,
				});
			sessionStorage.setItem(lastPageName, `${current}`);
			setList(data);
			setListData({ currentPage: Number(currentPage), totalPages, totalItems });
			return { data, currentPage, totalPages, totalItems };
		} catch (error) {
			showError('There was a problem on trying to get users.');
		} finally {
			setFetching(false);
		}
	};

	return (
		<ListContext.Provider
			value={{
				list,
				setList,
				listData,
				setListData,
				filter,
				setFilter,
				filterText,
				setFilterText,
				fetching,
				fetchList,
				orderBy,
				setOrderBy,
			}}
		>
			{children}
		</ListContext.Provider>
	);
};
